<div class="read-to-write position-relative">
  @if (mode() === EReadToWriteMode.read) {
    <h3>{{ label() }}</h3>
    <html-preview class="d-block html-preview" [data]="preview()" />
  } @else if (mode() === EReadToWriteMode.write || mode() === EReadToWriteMode.noData) {
    <div
      class="text-editor NgxEditor__Wrapper"
      [ngClass]="!isToolbarShown() ? 'm-0' : ''"
      [class.has-error]="(!formControl().pristine || isFormSubmitted()) && formControl().errors"
    >
      @if (isToolbarShown()) {
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
      }
      <ngx-editor
        [formControl]="formControl()"
        [editor]="editor"
        [placeholder]="noDataPlaceholder() || asterisksAddedLabel()"
        (click)="onFocus()"
      ></ngx-editor>
    </div>
    <app-custom-mat-error
      [control]="formControl()"
      [isFormSubmitted]="isFormSubmitted()"
      [isAppearanceOutline]="isAppearanceOutline()"
    ></app-custom-mat-error>
  }
</div>
